<template>
  <footer class="footer">
    <div class="container">
      <div
        class="footer__top d-flex justify-content-between align-items-center"
      >
        <div class="footer__logo">
          <router-link to="/">
            <img
              loading="lazy"
              src="@i/logo-gray.svg"
              width="210"
              height="52"
              alt="Sensation"
            />
          </router-link>
        </div>
        <div v-if="$social && !mq.xs" class="footer__social">
          <ul>
            <li v-for="(value, name) in $social" :key="name">
              <a
                :href="value.url"
                :aria-label="'Мы в ' + value.name"
                target="_blank"
                rel="noreferrer"
                ><Icon :icon="name"
              /></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__middle">
        <div class="footer__nav">
          <ul>
            <li>
              <a 
                href="https://наш.дом.рф/сервисы/единый-реестр-застройщиков/застройщик/23289"
                target="_blank"
              >
                Документы
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'News' }"> Новости </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Construction' }">
                Ход строительства
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'PlanSearch' }">Планировки</router-link>
            </li>
            <li>
              <!-- <router-link :to="{ name: 'Contacts' }"> Контакты </router-link> -->
              <router-link :to="{ path: '/', hash: '#contacts' }"
                >Контакты</router-link
              >
            </li>
          </ul>
        </div>
        <div v-if="$social && mq.xs" class="footer__social">
          <ul>
            <li v-for="(value, name) in $social" :key="name">
              <a
                :href="value.url"
                :aria-label="'Мы в ' + value.name"
                target="_blank"
                rel="noreferrer"
                ><Icon :icon="name"
              /></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__bottom d-md-flex align-items-md-center">
        <div class="footer__company">
          <a href="https://gk-osnova.ru/" target="_blank" rel="noopener">
            <img
              loading="lazy"
              src="@i/company-gray.svg"
              width="136"
              height="40"
              alt="Группа компаний Основа"
            />
          </a>
        </div>
        <div class="footer__policy">
          <p>
            Настоящий сайт носит исключительно информационный характер.
            Продолжая просмотр страниц сайта вы&nbsp;соглашаетесь со&nbsp;всеми
            условиями
            <router-link :to="{ name: 'Policy' }"
              >Пользовательского соглашения</router-link
            >,
            <a
              href="/Политика_обработки_персональных_данных.pdf"
              target="_blank"
            >
              Политикой обработки персональных данных</a
            > и 
            <a
              href="/cookie-policy"
              target="_blank"
            >
            Политикой использования cookie</a>. &copy;&nbsp;2021&nbsp;<a
              href="https://gk-osnova.ru/"
              target="_blank"
              rel="noopener"
              >АО ГК&nbsp;&laquo;Основа&raquo;</a
            >.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  inject: ["mq"],
};
</script>

<style scoped>
.footer {
  z-index: 49;
  display: block;
  margin-top: auto;
  padding: 33px 0;
  border-top: 1px solid #e5e5e5;
  background: #fff;
  font-size: 14px;
}

.footer a {
  color: inherit;
  font-weight: 600;
  text-decoration: none;
}

.footer__policy a {
  color: #3f4440;
}

.footer__nav ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer__nav ul li {
  margin: 0 30px 0 0;
  padding: 0;
}

.footer__nav ul li:last-child {
  margin-right: 0;
}

.footer__logo a {
  opacity: 0.4;
  transition: opacity 0.2s;
}

.footer__company a {
  opacity: 0.4;
  transition: opacity 0.2s;
}

.footer__social ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer__social ul li {
  margin: 0 12px 0 0;
  padding: 0;
}

.footer__social ul li:last-child {
  margin-right: 0;
}

.footer__social ul li a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ff0020;
}

.footer__social ul li a svg {
  transition: opacity 0.1s, fill 0.1s;
}

body.-notouch .footer a:hover {
  color: #ff0020;
}

body.-notouch .footer__logo a:hover {
  opacity: 1;
}

body.-notouch .footer__company a:hover {
  opacity: 1;
}

body.-notouch .footer__social ul li a:hover {
  background: #800010;
}

body.-notouch .footer__social ul li a:hover svg {
  opacity: 1;
  fill: #fff;
}

body.-notouch .footer__social ul li a:active {
  background: #800010;
}

.footer__top {
  padding: 0 0 23px;
}

.footer__logo {
  flex: 0 0 210px;
}

.footer__middle {
  position: relative;
}

.footer__nav {
  position: absolute;
  top: -60px;
  left: 225px;
  font-weight: normal;
  font-size: 16px;
}

.footer__agent {
  margin-bottom: 20px;
}

.footer__agent-link {
  text-decoration: underline;
  cursor: pointer;
}

.footer__agent-link:hover {
  text-decoration: none;
}

.footer__bottom {
  padding: 23px 0 0;
  border-top: 1px solid rgb(0 0 0 / 0.1);
}

.footer__company {
  flex: 0 0 136px;
  margin-right: 43px;
}

.footer__policy {
  margin-right: 40px;
  color: #8c8f8c;
}

.footer__policy p {
  margin: 0 0 8px;
}

.footer__policy p:last-child {
  margin: 0;
}

.footer__dev {
  flex: 0 0 112px;
}

.footer__dev a img {
  opacity: 0.4;
  transition: opacity 0.2s;
}

.footer__dev span {
  display: none;
  color: #8c8f8c;
  font-weight: 300;
}

body.-notouch .footer__dev a:hover img {
  opacity: 1;
}

@media (max-width: 1279px) {
  .footer__middle {
    padding: 23px 0;
    border-top: 1px solid rgb(0 0 0 / 0.1);
  }

  .footer__nav {
    position: relative;
    top: 0;
    left: 0;
  }
}

@media (max-width: 991px) {
  .footer__nav {
    margin-bottom: -10px;
  }

  .footer__nav ul {
    flex-wrap: wrap;
  }

  .footer__nav ul li {
    width: 50%;
    margin: 0 0 10px;
    padding-right: 15px;
  }

  .footer__policy {
    margin-right: 35px;
  }
}

@media (max-width: 767px) {
  .footer__company {
    margin-right: 0;
    margin-bottom: 23px;
    text-align: center;
  }

  .footer__policy {
    margin-right: 0;
    text-align: center;
  }

  .footer__dev {
    margin-top: 23px;
    padding-top: 23px;
    border-top: 1px solid rgb(0 0 0 / 0.1);
    text-align: center;
  }

  .footer__dev a {
    display: inline-flex;
    align-items: center;
  }

  .footer__dev span {
    display: block;
    max-width: 200px;
    margin-left: 20px;
    line-height: 1.2;
    text-align: left;
  }
}

@media (max-width: 575px) {
  .container {
    padding-right: 32px;
    padding-left: 32px;
  }

  .footer__nav ul li {
    width: auto;
    margin: 0 0 24px;
    padding-right: 25px;
  }

  .footer__middle {
    padding: 16px 0;
    border-top: none;
  }

  .footer__top {
    padding: 0;
  }

  .footer__nav {
    margin-bottom: 16px;
  }

  .footer__company {
    text-align: left;
  }

  .footer__policy {
    font-size: 14px;
    text-align: left;
  }

  .footer__policy a {
    font-size: 14px;
  }

  .footer__dev span {
    max-width: 120px;
    font-size: 12px;
  }
}

@media (max-width: 374px) {
  .footer__nav ul li {
    font-size: 15px;
  }
}
</style>
